import Service				from "./../../Libs/Service";
import _					from "lodash";

import { Server } 			from "./Server";
import {Version} from "./Version";

let Localization = new Service({

	Name: "Localization",

	Events: {

		"Settings Selected": function(settings) {

			//this.updateParams();

		}

	},

	Actions: {

		"Localization": function(localizationByVersion, data) {

			_.each(localizationByVersion, (versionLocalizations, versionId) => {

				_.each(versionLocalizations, (localeLocalizations, locale) => {

					_.each(localeLocalizations, (newLocalization, localizationCodename) => {

						this.setLocalization(parseInt(versionId), locale, localizationCodename, newLocalization);

					});

				});

				//Если установлен этот маркер - значит отправляются все ассеты указанной версии (создание новой версии)
				if (data.LocalizationVersionId) {

					Broadcast.call(`Version Localization Loaded`, [versionId]);
					Broadcast.call(`Version Localization Loaded:${versionId}`);
					if ((Version.SelectedVersion?.baseVersionId || Version.SelectedVersion?.id) === parseInt(versionId)) Broadcast.call(`Selected Version Localization Loaded`);

				}

			});

			//Если установлен этот маркер - значит это первоначальное получение данных о только что впервые открытом проекте (все ассеты всех версий проекта загружаются)
			if (data.LocalizationProjectId) {

				Broadcast.call(`Project Localization Loaded`, [data.LocalizationProjectId]);
				Broadcast.call(`Project Localization Loaded:${data.LocalizationProjectId}`);
				if ((Project.SelectedProject?.id) === parseInt(data.LocalizationProjectId)) Broadcast.call(`Selected Project Localization Loaded`);

			}

			//Помечаем этим маркером первоначальную загрузку локализации первого наблюдаемого проекта
			this.loaded = true;

			//this.updateLocalization(texts);

		},

		"LocalizationOriginal": function(localizationOriginalByVersions, data) {

			_.each(localizationOriginalByVersions, (versionLocalizationsOriginal, versionId) => {

				this.LocalizationOriginalByVersion[versionId] = {};
				this.LocalizationOriginalByVersionByLocaleByCodename[versionId] = {};

				_.each(versionLocalizationsOriginal, (localeLocalizationsOriginal, locale) => {

					_.each(localeLocalizationsOriginal, (newLocalizationOriginal, localizationCodename) => {

						this.setLocalizationOriginal(parseInt(versionId), locale, localizationCodename, newLocalizationOriginal);

					});

				});

				//Если установлен этот маркер - значит отправляются все original ассеты указанной версии (обновление проекта из репозитория)
				if (data.LocalizationVersionId) {

					Broadcast.call(`Version Localization Original Loaded`, [versionId]);
					Broadcast.call(`Version Localization Original Loaded:${versionId}`);
					if ((Version.SelectedVersion?.baseVersionId || Version.SelectedVersion?.id) === parseInt(versionId)) Broadcast.call(`Selected Version Localization Original Loaded`);

				}

			});

			//Если установлен этот маркер - значит это первоначальное получение данных о только что впервые открытом проекте (все ассеты всех версий проекта загружаются)
			if (data.LocalizationProjectId) {

				Broadcast.call(`Project Localization Original Loaded`, [data.LocalizationProjectId]);
				Broadcast.call(`Project Localization Original Loaded:${data.LocalizationProjectId}`);
				if ((Project.SelectedProject?.id) === parseInt(data.LocalizationProjectId)) Broadcast.call(`Selected Project Localization Loaded`);

			}

		},

		"ChangedLocalization": function(changedLocalizationData) {

			_.each(changedLocalizationData, changedLocalizationData => {

				let oldLocalization = this.LocalizationByVersionByLocaleByCodename[changedLocalizationData.versionId]?.[changedLocalizationData.locale]?.[changedLocalizationData.localizationCodename];

				this.setLocalization(changedLocalizationData.versionId, changedLocalizationData.locale, changedLocalizationData.localizationCodename, changedLocalizationData.localization);

				this.detectLocalizationChanges(changedLocalizationData.versionId, oldLocalization, changedLocalizationData.localization);

			});

		}

	},

	init() {

		this.loaded = false;

		this.Localization = {};
		this.LocalizationByVersion = {};
		this.LocalizationByVersionByLocaleByCodename = {};

		this.LocalizationOriginal = {};
		this.LocalizationOriginalByVersion = {};
		this.LocalizationOriginalByVersionByLocaleByCodename = {};

	},

	setLocalizationOriginal(versionId, locale, localizationCodename, localizationOriginal) {

		this.LocalizationOriginal[localizationOriginal.id] = localizationOriginal;

		if (!this.LocalizationOriginalByVersion[localizationOriginal['version_id']]) this.LocalizationOriginalByVersion[localizationOriginal['version_id']] = {};
		this.LocalizationOriginalByVersion[localizationOriginal['version_id']][localizationOriginal.id] = localizationOriginal;

		if (!this.LocalizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']]) this.LocalizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']] = {};
		if (!this.LocalizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']][localizationOriginal['locale']]) this.LocalizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']][localizationOriginal['locale']] = {};
		this.LocalizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']][localizationOriginal['locale']][localizationOriginal.codename] = localizationOriginal;

	},

	setLocalization(versionId, locale, localizationCodename, localization) {

		let oldLocalization = this.LocalizationByVersionByLocaleByCodename[versionId]?.[locale]?.[localizationCodename];

		if (localization) {

			this.Localization[localization.id] = localization;

			if (!this.LocalizationByVersion[localization['version_id']]) this.LocalizationByVersion[localization['version_id']] = {};
			this.LocalizationByVersion[localization['version_id']][localization.id] = localization;

			if (!this.LocalizationByVersionByLocaleByCodename[localization['version_id']]) this.LocalizationByVersionByLocaleByCodename[localization['version_id']] = {};
			if (!this.LocalizationByVersionByLocaleByCodename[localization['version_id']][localization['locale']]) this.LocalizationByVersionByLocaleByCodename[localization['version_id']][localization['locale']] = {};
			this.LocalizationByVersionByLocaleByCodename[localization['version_id']][localization['locale']][localization.codename] = localization;

		} else {

			if (oldLocalization) {

				delete this.Localization[oldLocalization.id];
				if (this.LocalizationByVersion[oldLocalization['version_id']]) delete this.LocalizationByVersion[oldLocalization['version_id']][oldLocalization.id];
				if (this.LocalizationByVersionByLocaleByCodename[oldLocalization['version_id']]?.[oldLocalization.locale]) delete this.LocalizationByVersionByLocaleByCodename[oldLocalization['version_id']][oldLocalization.locale][oldLocalization.codename];

			}

		}

	},

	//Определяем какие конкретно изменения произошли
	detectLocalizationChanges(versionId, oldLocalization, newLocalization) {

		//Если такой объект изменений локализации уже был на клиенте
		if (oldLocalization) {

			if (newLocalization) {

				if (newLocalization['version_id'] === Version.SelectedVersion?.id) {

					Broadcast.call(`Selected Version Localization Changed`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);
					Broadcast.call(`Selected Version Localization Changed:${newLocalization.codename}`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);

				} else {

					Broadcast.call(`Localization Changed`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);
					Broadcast.call(`Localization Changed:${versionId}:${newLocalization.codename}`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);

				}

			}

			//Если изменения ессета удалили (возможно reset)
			else {

				//Если это локализация текущей просматриваемой пользователем версии проекта
				if (oldLocalization['version_id'] === Version.SelectedVersion?.id) {

					//Если локализация была в json файле настроек
					if (this.LocalizationOriginalByVersionByLocaleByCodename[Version.Versions[oldLocalization['version_id']]?.baseVersionId]?.[oldLocalization.locale]?.[oldLocalization.codename]) {

						Broadcast.call(`Selected Version Localization Restored`, [oldLocalization['version_id'], oldLocalization.codename]);
						Broadcast.call(`Selected Version Localization Restored:${oldLocalization.codename}`, [oldLocalization['version_id'], oldLocalization.codename]);

					} else {

						Broadcast.call(`Selected Version Localization Deleted`, [oldLocalization['version_id'], oldLocalization.codename]);
						Broadcast.call(`Selected Version Localization Deleted:${oldLocalization.codename}`, [oldLocalization['version_id'], oldLocalization.codename]);

					}

				} else {

					//Если локализация была в json файле настроек
					if (this.LocalizationOriginalByVersionByLocaleByCodename[Version.Versions[oldLocalization['version_id']]?.baseVersionId]?.[oldLocalization.locale]?.[oldLocalization.codename]) {

						Broadcast.call(`Localization Restored`, [oldLocalization]);
						Broadcast.call(`Localization Restored:${versionId}:${oldLocalization.codename}`, [oldLocalization]);

					} else {

						Broadcast.call(`Localization Deleted`, [oldLocalization]);
						Broadcast.call(`Localization Deleted:${versionId}:${oldLocalization.codename}`, [oldLocalization]);

					}

				}

			}

		}

		//Если такого объекта изменений локализации ещё не было на клиенте
		else {

			//Если в новых пришедших данных есть объект изменённых данных локализации
			if (newLocalization) {

				//Если это локализация текущей просматриваемой пользователем версии проекта
				if (newLocalization['version_id'] === Version.SelectedVersion?.id) {

					Broadcast.call(`Selected Version Localization Changed`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);
					Broadcast.call(`Selected Version Localization Changed:${newLocalization.codename}`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);

				} else {

					Broadcast.call(`Localization Changed`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);
					Broadcast.call(`Localization Changed:${versionId}:${newLocalization.codename}`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);

				}

			}

			//Если изменения локализации удалили (возможно reset)
			else {

				//Тут можно ничего не делаеть. Изменений локализации и так не было, но пришло сообщение что их удалили

			}

		}

	},

	getVersionLocalization(version) {

		if (!version) return {};

		let localization = {};
		
		_.each(this.LocalizationOriginalByVersion[version.baseVersionId || version.id], text => {

			if (!localization[text.locale]) localization[text.locale] = {};

			localization[text.locale][text.codename] = _.cloneDeep(text);

		});

		_.each(this.LocalizationByVersion[version.id], text => {

			if (!localization[text.locale]) localization[text.locale] = {};

			localization[text.locale][text.codename] = _.merge(localization[text.locale][text.codename] || {}, text);

		});

		let endCardVersion = EndCard.getEndCardVersion(Project.Projects[version['project_id']], version);

		if (endCardVersion) _.merge(localization, this.getVersionLocalization(endCardVersion));

		return localization;

	},

	cleanVersionLocalization(localization) {

		_.each(localization, localeLocalization => {

			_.each(localeLocalization, (localization, localizationCodename) => {

				localeLocalization[localizationCodename] = this.getMergedLocalization(localization)

			});

		});

		return localization;

	},

	isLocalizationStyleChanged(version, locale, localizationCodename, styleName) {

		if (!version) return false;

		if (!this.LocalizationByVersionByLocaleByCodename[version.id]?.[locale]?.[localizationCodename]?.styles) return false;
		if (!this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id]?.[locale]?.[localizationCodename]?.styles) return false;

		return this.LocalizationByVersionByLocaleByCodename[version.id][locale][localizationCodename].styles.hasOwnProperty(styleName) && this.LocalizationByVersionByLocaleByCodename[version.id][locale][localizationCodename].styles[styleName] !== this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id][locale][localizationCodename].styles[styleName];

	},

	isLocalizationStylesChanged(version, locale, localizationCodename) {

		if (!version) return false;

		if (!this.LocalizationByVersionByLocaleByCodename[version.id]?.[locale]?.[localizationCodename]?.styles) return false;
		if (!this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id]?.[locale]?.[localizationCodename]?.styles) return false;

		let result = false;

		let styleNames = _.uniq(_.keys(this.LocalizationByVersionByLocaleByCodename[version.id][locale][localizationCodename].styles).concat(_.keys(this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id][locale][localizationCodename].styles)));

		_.each(styleNames, styleName => {

			if (this.isLocalizationStyleChanged(version, locale, localizationCodename, styleName)) result = true;

		});

		return result;

	},

	isLocalizationMessageChanged(version, locale, localizationCodename) {

		if (!version) return false;

		if (!this.LocalizationByVersionByLocaleByCodename[version.id]?.[locale]?.[localizationCodename]) return false;
		if (!this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id]?.[locale]?.[localizationCodename]) return false;

		return this.LocalizationByVersionByLocaleByCodename[version.id][locale][localizationCodename].message !== this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id][locale][localizationCodename].message;

	},

	isLocalizationHasOrigin(version, locale, localizationCodename) {

		return !!this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id]?.[locale]?.[localizationCodename];

	},

	getMergedLocalization(localization) {

		return _.extend({text: localization["message"]}, _.cloneDeep(_.omitBy(localization.styles, (v, k) => v === '#deleted#' || k === 'type')));

	},

	changeLocalizationMessage(versionId, locale, codename, text) {

		Server.sendToSocket({
			ChangeLocalizationMessage: {
				versionId,
				locale,
				codename,
				text
			}
		});

	},

	checkLocalizationStyle(styleName, styleValue) {

		if (styleName === 'fontSize' && styleValue <= 0) styleValue = 1;

		let styleProps = Metadata.TextStylesByCodename[styleName];

		if (styleProps?.type === 'number') styleValue = parseFloat(styleValue);
		if (styleProps?.type === 'boolean') styleValue = !!styleValue;

		return styleValue;

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Localization) Localization = window.Localization;
else window.Localization = Localization;

export { Localization }

